import React, { useState, useCallback } from 'react';
import { ExpandableTable } from '@hmsexp/component-library';
import { renderCell } from './RenderCell';
import Pagination from '../../../components/Common/Pagination';
import { View } from '../../../components/Common/react-native-components';
import container from '../container';

const ExpandableGrid = ({ columns, data, pageSize = 3 }) => {
  const [hoveredRowId, setHoveredRowId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: null
  });
 const handleSort = (columnKey, direction) => {
  console.log(columnKey, direction, 'lll');
  setSortConfig({ field: columnKey, direction });
  setCurrentPage(1);
};


  const patchColumns = (cols, hoveredRowId, setHoveredRowId) => {
    return cols.map(col => {
      const patched = {
        ...col,
        ...(col.field && { Cell: renderCell(hoveredRowId, setHoveredRowId, handleSort, sortConfig) })
      };

      if (col.columns && Array.isArray(col.columns)) {
        patched.columns = patchColumns(col.columns, hoveredRowId, setHoveredRowId);
      }

      return patched;
    });
  };
  const patchedColumns = patchColumns(columns, hoveredRowId, setHoveredRowId);

  const totalPages = Math.ceil(data.length / pageSize);
  const sortedData = React.useMemo(() => {
    if (!sortConfig.field) return data;

    return [...data].sort((a, b) => {
      const valA = a[sortConfig.field];
      const valB = b[sortConfig.field];

      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [data, sortConfig]);

  const paginatedData = sortedData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const hoverFn = row => {
    // setHoveredRowId(row?.topic);
  };

  return (
    <View style={{ padding: 3, display: 'flex' }}>
      <ExpandableTable
        columns={patchedColumns}
        collapsibleIconsDirection='left'
        applyRenderRowToNestedRows={true}
        // renderRow={renderRow}
        data={paginatedData}
        style={{
          container:{
            borderWidth:0
          },
          containerStyle: {
            backgroundColor: 'white'
          },
          headerCellWrapper: {
            backgroundColor: '#fff'
          },
          headerContainer: {
            height: 60,
            borderWidth: 0,
            backgroundColor: '#fff'
          },
          headerTextWrapperStyle: {
            backgroundColor: '#fff',
            fontWeight: '800'
          }
        }}
        getCellProps={({ column, value, row }) => {
          const isHovered = hoveredRowId === row.topic;

          return {
            containerStyle: {
              backgroundColor: '#fff'
            }
          };
        }}
        hoverFn={hoverFn}
        hasNestedData
        showTitleBar={false}
      />
      <Pagination
        totalRecords={data.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={page => setCurrentPage(page)}
      />
    </View>
  );
};

export default ExpandableGrid;
